
export default function employee( state = [], action = {} ){

	switch( action.type ){
		case 'GET_EMPLOYEE':
            return action.employee
        case 'GET_EMPLOYEE_COMPANY':
            return action.employee
        case 'DELETE_EMPLOYEE':
            return action.employee
        case 'APPROVE_EMPLOYEE':
            return action.employee
        case 'REQUEST_JOIN':
            return action.employee
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/employee/employee.reducer.js